import * as angular from "angular"
import {IController} from "angular";

export class PlanningDepotsSelectionTableRowCtrl implements IController {
  depot: any;
  isSelected: any;
  onSelect: Function;

  /* @ngInject */
  constructor() {
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningDepotsSelectionTableRow', {
    bindings: {
      depot: '<',
      isSelected: '<',
      onSelect: '&'
    },
    template: require('./planning-depots-selection-table-row.html').default,
    controller: PlanningDepotsSelectionTableRowCtrl
  });
